import {
  createStore,
  dynaduxDebugMiddleware,
} from "dynadux";

import {INavigateTo} from "../sections/application/interfaces/INavigateTo";

import {createAppSection} from "../sections/application";
import {createUserAuthenticationSection} from "../sections/user-authnentication";
import {createWorkzonesManagementSection} from "../sections/workzones-management";

import {appConfig} from "../sections/application/config/appConfig";

const getStoreDebugMode = ()=> localStorage.getItem('_debug_appStore') === 'true';

(window as any)._debug_appStoreActivation = (activate?: boolean)=> {
  if (activate === undefined) {
    console.log('_debug_appStore is', getStoreDebugMode());
    return;
  }
  localStorage.setItem('_debug_appStore', activate.toString());
  console.log('_debug_appStore set to', getStoreDebugMode());
};

export const createAppStore = (
  {navigateTo}: {
    navigateTo: (navigateTo: INavigateTo) => void;
  },
) => {
  const store = createStore({
    middlewares: [
      getStoreDebugMode() && dynaduxDebugMiddleware(
        {
          debuggerStoreName: '_debug_appStore',
          consoleDispatch: true,
          consolePayload: true,
          consoleState: true,
        },
      ),
    ],
  });

  const appStore = {
    provider: store.provider,

    app: createAppSection({
      store,
      navigateTo,
      apiBaseUrl: appConfig.apiBaseUrl,
    }),
    userAuth: createUserAuthenticationSection(store),
    workzonesManagement: createWorkzonesManagementSection(store),
  };

  if (getStoreDebugMode()) {
    (window as any)._debug_dynaduxStore = store;
  }

  return appStore;
};
